<template>
  <div class="roles-page">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'roles-page',
}
</script>
